import { render, staticRenderFns } from "./post_actions.vue?vue&type=template&id=0a7d8d36&scoped=true&"
import script from "./post_actions.vue?vue&type=script&lang=js&"
export * from "./post_actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d8d36",
  null
  
)

export default component.exports